// extracted by mini-css-extract-plugin
export default {"expanded":"CaseDeliveryStatusField_expanded__EbdbB"};